import React, { useMemo } from 'react';
import { Button } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  
  // Memoize icon to ensure it updates
  const icon = useMemo(() => {
    return theme === 'light' ? <MoonOutlined /> : <SunOutlined />;
  }, [theme]);

  // Memoize button style to prevent unnecessary re-renders
  const buttonStyle = useMemo(() => ({
    fontSize: '18px',
    width: '42px',
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
    color: 'var(--text-primary)',
    background: 'transparent',
  }), []);

  return (
    <Button
      type="text"
      icon={icon}
      onClick={toggleTheme}
      style={buttonStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'var(--bg-hover)';
        e.currentTarget.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.transform = 'scale(1)';
      }}
    />
  );
};

export default ThemeToggle;
